/**
 * MetaDefinitionsProvider
 * HOC for wrapping the provided component with MetaDefinitionsProvider
 */

import React from 'react'

import MetaDefinitionsProvider from './meta-definitions-provider'

export default function withMetaDefinitions (WrappedComponent) {
  return function MetaDefinitionsProviderHOC(props) {
    return (
      <MetaDefinitionsProvider {...props}>
        <WrappedComponent {...props} />
      </MetaDefinitionsProvider>
    )
  }
}
